import React from 'react';
import { styled } from '@this/constants/themes';
import type TravelerInformation from '@this/src/domain/traveler_information';
import type { ShinkansenSeatType } from '@this/src/domain/traveler_information';
import { observer } from 'mobx-react';
import type { Traveler } from './type';

export type TravelerRailwayFormData = {
  shinkansenSeat: Traveler['shinkansenSeat'] | null;
};

type Props = {
  travelerInformation: TravelerInformation;
  classNameForModifiedField: (...path: (string | number)[]) => string;
};

const OrderItemTravelerRailwayForm: React.FC<Props> = ({ travelerInformation, classNameForModifiedField }) => {
  return (
    <Container>
      <Label className={classNameForModifiedField('shinkansenSeat')}>座席の希望</Label>
      <FormContainer>
        <Select
          value={travelerInformation.shinkansenSeatType}
          onChange={e => {
            travelerInformation.shinkansenSeatType = e.target.value as ShinkansenSeatType;
          }}
        >
          <option value="指定なし">指定なし</option>
          <option value="窓側">窓側</option>
          <option value="通路側">通路側</option>
          <option value="その他">その他</option>
        </Select>
        {travelerInformation.shinkansenSeat === 'その他' && (
          <Input
            value={travelerInformation.shinkansenSeatInfo ?? ''}
            onChange={e => {
              travelerInformation.shinkansenSeatInfo = e.target.value;
            }}
          />
        )}
      </FormContainer>
    </Container>
  );
};

const Container = styled.div``;

const Label = styled.label``;

const Select = styled.select`
  height: 24px;
`;

const Input = styled.input.attrs({ type: 'text' })``;

const FormContainer = styled.div`
  display: flex;
  align-items: center;

  ${Select} + ${Input} {
    margin-left: 5px;
  }
`;

export default observer(OrderItemTravelerRailwayForm);
